import {
  cryptorsAdminControllerGenerateCaptureLink,
  type CaptureLink,
  unwrapApiResponse,
} from "@cryptors/api-client";
import { useMutation } from "@tanstack/react-query";

const postCaptureLink = async ({
  id,
  expiresAt,
}: {
  id: number;
  expiresAt: string;
}): Promise<CaptureLink> => {
  return unwrapApiResponse(
    cryptorsAdminControllerGenerateCaptureLink<true>({
      body: { expiresAt },
      path: { id },
      throwOnError: true,
    }),
  );
};

export const useGenerateCaptureLink = () =>
  useMutation({ mutationFn: postCaptureLink });
